import { render, staticRenderFns } from "./create-topic.vue?vue&type=template&id=5f09fe74&scoped=true&lang=html&"
import script from "./create-topic.vue?vue&type=script&lang=js&"
export * from "./create-topic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f09fe74",
  null
  
)

export default component.exports